import inject from "scripts/ioc/inject";
import BaseFormView from "scripts/views/baseFormView";
import ForgotPasswordModel from "scripts/models/forgotPasswordModel";
import templateForgotPasswordForm from "templates/forgotPasswordForm.hbs";

class ForgotPasswordFormView extends BaseFormView {
  get hybridForgotPasswordEmailUrl() {
    return process.env.PATRON_UI_HYBRID_FORGOT_PASSWORD_EMAIL_URL;
  }

  get template() {
    return templateForgotPasswordForm;
  }

  get events() {
    return {
      "input form *[name]": "onInputEnableSubmit",
      "submit form": "onSubmit",
    };
  }

  constructor(options, securityService = inject("securityService")) {
    super(options);

    this.securityService = securityService;

    const targetUrl = this.hybridForgotPasswordEmailUrl
      ? this.hybridForgotPasswordEmailUrl
      : `${window.location.origin}/login`;

    this.bindModel(
      new ForgotPasswordModel({
        targetUrl: targetUrl,
      }),
    );
  }

  render() {
    this.$el.html(this.template());

    this.loaderView
      .appendTo(this.$el.find(".bb-form-submit-button-loader-region"))
      .render();

    return this;
  }

  onSubmitSucceeded() {
    this.enableSubmit(true);
    this.trigger("success");
  }

  toJSON() {
    const json = super.toJSON();

    if (this.securityService.authScope) {
      json.scope = [this.securityService.authScope];
    }

    return json;
  }
}

export default ForgotPasswordFormView;
